if (!customElements.get('sl-hero-film')) {
  customElements.define('sl-hero-film', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('button');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.mobile = matchMedia('(max-width: 768px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.reduced.matches || Boolean(navigator.connection?.saveData);
      this.visible = true;
      this.toggle.hidden = false;
      this.syncLabel = () => { this.toggle.textContent = this.video.paused ? this.toggle.dataset.play : this.toggle.dataset.pause; };
      this.play = () => {
        if (this.userPaused || !this.visible || document.hidden) return;
        if (!this.video.getAttribute('src')) this.video.src = this.mobile.matches ? this.dataset.mobile : this.dataset.desktop;
        this.video.muted = true;
        this.video.play().catch(() => this.syncLabel());
      };
      this.video.addEventListener('playing', () => { this.classList.add('has-frame'); this.syncLabel(); }, options);
      this.video.addEventListener('pause', this.syncLabel, options);
      this.video.addEventListener('error', () => { this.classList.remove('has-frame'); this.syncLabel(); }, options);
      this.toggle.addEventListener('click', () => {
        this.userPaused = !this.video.paused;
        if (this.userPaused) this.video.pause(); else this.play();
      }, options);
      this.mobile.addEventListener('change', () => {
        this.video.pause(); this.classList.remove('has-frame');
        this.video.removeAttribute('src'); this.video.load(); this.play();
      }, options);
      this.reduced.addEventListener('change', () => {
        this.userPaused = this.reduced.matches;
        if (this.userPaused) this.video.pause(); else this.play();
      }, options);
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.video.pause(); else this.play(); }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) this.play(); else this.video.pause();
      }, { threshold: 0.05 });
      this.observer.observe(this); this.play();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.video?.pause(); }
  });
}
